import { $, $$, onReady, isMobile } from '../nth-ms26-core/js/env';
import { createCarousel } from '../nth-ms26-core/js/carousel';
import { fetchCmsHtml, toFragment } from '../nth-ms26-core/js/ajax';

/*
 * Banner trên CMS dùng lại template cũ banner-home (markup Swiper .swiper-banner) — trang này không tải Swiper,
 * nên đọc ảnh/link từ markup cũ rồi dựng lại thành carousel mới (cùng markup với ./html/banner.html.twig).
 */
function adoptLegacyBanner(frame) {
  const legacy = $('.swiper-banner', frame);
  if (!legacy) return;
  const host = legacy.parentNode;
  const slides = $$('.swiper-slide a', legacy);
  host.textContent = '';
  if (!slides.length) return;
  const car = document.createElement('div');
  car.className = 'carousel';
  car.setAttribute('data-carousel', '');
  car.dataset.autoplay = '5000';
  car.setAttribute('role', 'region');
  car.setAttribute('aria-roledescription', 'carousel');
  car.setAttribute('aria-label', 'Sự kiện nổi bật');
  const view = document.createElement('div');
  view.className = 'carousel__viewport';
  slides.forEach((a, i) => {
    const img = $('img', a);
    const slide = document.createElement('a');
    slide.className = `carousel__slide${i === 0 ? ' is-active' : ''}`;
    slide.href = a.getAttribute('href') || '#';
    if (a.getAttribute('target') === '_blank') {
      slide.target = '_blank';
      slide.rel = 'noopener';
    }
    const pic = document.createElement('img');
    pic.src = img ? img.getAttribute('src') || img.getAttribute('data-src') || '' : '';
    pic.alt = img ? img.alt : '';
    pic.width = 724;
    pic.height = 408;
    pic.decoding = 'async';
    if (i) pic.loading = 'lazy';
    slide.appendChild(pic);
    view.appendChild(slide);
  });
  const pad = String(slides.length).padStart(2, '0');
  car.appendChild(view);
  car.insertAdjacentHTML('beforeend', `<div class="carousel__nav">
    <div class="carousel__dots" data-carousel-dots></div>
    <button class="carousel__arrow carousel__arrow--prev" type="button" data-carousel-prev aria-label="Banner trước"><i class="ico ico--prev" aria-hidden="true"></i></button>
    <p class="carousel__count" aria-hidden="true"><b data-carousel-current>01</b>/<span data-carousel-total>${pad}</span></p>
    <button class="carousel__arrow carousel__arrow--next" type="button" data-carousel-next aria-label="Banner sau"><i class="ico ico--next" aria-hidden="true"></i></button>
  </div>`);
  host.appendChild(car);
}

// Banner chỉ tự chạy khi màn Tin tức đang hiển thị (PC: màn active, MB: đang trong khung nhìn)
function initBanner(frame) {
  adoptLegacyBanner(frame);
  const el = $('[data-carousel]', frame);
  if (!el) return;
  const car = createCarousel(el);
  if (isMobile()) {
    new IntersectionObserver(([en]) => (en.isIntersecting ? car.play() : car.pause()), { threshold: 0.3 }).observe(el);
  } else {
    const sync = () => (frame.classList.contains('is-active') ? car.play() : car.pause());
    document.addEventListener('nth:frame', sync);
    sync();
  }
}

/*
 * Tab danh mục: tab là link thật tới trang danh sách. Có JS thì tải danh sách tại chỗ:
 *   endpoint "{site}/tin-tuc-ajax/home-news.{page}.html?cate={cate}" → chuỗi JSON chứa <ul>.
 * Kết quả cache theo danh mục; lỗi mạng → mở hẳn trang danh sách (link gốc của tab).
 */
function initTabs(feed) {
  const list = $('[data-news-list]', feed);
  const tabs = $$('[data-cate]', feed);
  const endpoint = (feed.dataset.endpoint || '').trim();
  const cache = new Map();
  let ctrl;
  if (tabs[0]) cache.set(tabs[0].dataset.cate, list.innerHTML);

  const swap = (html) => {
    list.classList.add('is-loading');
    setTimeout(() => {
      list.innerHTML = '';
      list.appendChild(toFragment(html));
      list.setAttribute('aria-busy', 'false');
      requestAnimationFrame(() => list.classList.remove('is-loading'));
    }, 220);
  };

  tabs.forEach((tab) => tab.addEventListener('click', async (e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    if (tab.classList.contains('is-active')) return;
    tabs.forEach((t) => {
      const on = t === tab;
      t.classList.toggle('is-active', on);
      if (on) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
    $$('[data-news-more]', feed).forEach((a) => { a.href = tab.href; });

    const cate = tab.dataset.cate;
    if (cache.has(cate)) {
      swap(cache.get(cate));
      return;
    }
    if (!endpoint) {
      // bản mẫu không có server: giữ danh sách hiện tại, chỉ chạy hiệu ứng đổi tab
      swap(list.innerHTML);
      return;
    }
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    list.setAttribute('aria-busy', 'true');
    list.classList.add('is-loading');
    try {
      const html = await fetchCmsHtml(endpoint.replace('{cate}', encodeURIComponent(cate)).replace('{page}', '1'), { signal: ctrl.signal });
      cache.set(cate, html);
      swap(html);
    } catch (err) {
      if (err.name !== 'AbortError') window.location.href = tab.href;
    }
  }));
}

onReady(() => {
  const frame = $('#tin-tuc');
  if (!frame) return;
  initBanner(frame);
  const feed = $('[data-news-feed]', frame);
  if (feed) initTabs(feed);
});
